export default __webpack_public_path__ + "static/media/result-health.30477952.svg";